<template>
  <banners>
    <div class="mx-auto max-w-screen-lg px-4 py-4 md:px-10">
      <h1 class="my-4 text-left text-2xl text-dark-blue md:my-6">
        Add Carriers
      </h1>
      <div
        class="flex flex-col md:rounded-md md:border md:border-light-gray md:p-8 md:shadow-primary"
      >
        <div>
          <div class="my-1 flex content-center">
            <h1 class="self-start pt-1 text-left text-1lg text-dark-gray">
              Access Request Pending...
            </h1>
            <img
              class="-mt-2 justify-self-end"
              src="@/assets/highway-badge.svg"
              alt="highway icon"
            />
          </div>

          <p class="mb-5 text-left text-1md text-dark-gray">
            Your request to {{ carrierName }} has been sent. You can expect a
            response soon.
          </p>

          <p class="mb-5 text-left text-xxs text-gray-400">
            If your request is not approved shortly, please follow up with
            representatives of the carrier or contact
            <a
              class="mb-5 cursor-pointer text-xxs text-yellow-500"
              href="mailto:service@highway.com"
              >service@highway.com</a
            >
            for help.
          </p>
        </div>
        <div class="flex flex-col-reverse justify-end gap-4 md:flex-row">
          <button-main
            class="self-center md:max-w-max"
            variant="secondary"
            @click="$router.push('/dispatcher/add-carriers')"
          >
            Add Another Carrier
          </button-main>
          <button-main
            class="self-center md:max-w-max"
            @click="$router.push('/dispatcher')"
          >
            Done
          </button-main>
        </div>
      </div>
    </div>
  </banners>
</template>
<script>
import ButtonMain from '@/components/Button.vue';
import Banners from '@/components/Banners.vue';

export default {
  name: 'DistpacherAccessPending',
  components: {
    Banners,
    ButtonMain,
  },
  data() {
    return {};
  },
  computed: {
    carrierName() {
      return this.$store.state.carriers?.carrierDetails?.legal_name || '';
    },
    contactRecipients() {
      const carrier = this.$store.state.carriers?.carrierDetails;
      if (carrier && carrier.email_addresses && carrier.phones) {
        const { email_addresses, phones } = carrier;
        return [...email_addresses, ...phones];
      }
      return [];
    },
  },
  async created() {},
  methods: {},
};
</script>
<style>
.max-h-max {
  height: max-content;
}
</style>
